import { render, staticRenderFns } from "./FormEkspektasiPerilakuBawahan.vue?vue&type=template&id=5c6932dc&lang=html&"
import script from "./FormEkspektasiPerilakuBawahan.vue?vue&type=script&lang=js&"
export * from "./FormEkspektasiPerilakuBawahan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports